import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { ICartCountResponse, ICartResponse } from '@/common/interfaces/cart.interface';

interface CartState {
  cartItems: ICartResponse;
  cartCountObject: ICartCountResponse;
  showAddCartSuccessMessage: boolean;
  showAddStoreSuccessMessage: boolean;
  isLoading: boolean;
  isOpened: boolean;
}

const initialState: CartState = {
  cartItems: [] as ICartResponse,
  cartCountObject: {} as ICartCountResponse,
  showAddCartSuccessMessage: false,
  showAddStoreSuccessMessage: false,
  isLoading: false,
  isOpened: false,
};

export const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCartItems: (state, action: PayloadAction<ICartResponse>) => {
      state.cartItems = action.payload;
    },
    setCartCountObject: (state, action: PayloadAction<ICartCountResponse>) => {
      state.cartCountObject = action.payload;
    },
    updateCartCountObject: (state, action: PayloadAction<Partial<ICartCountResponse>>) => {
      state.cartCountObject = {
        ...state.cartCountObject,
        ...action.payload,
      };
    },
    enableAddCartSuccessMessage: (state) => {
      state.showAddCartSuccessMessage = true;
    },
    disableAddCartSuccessMessage: (state) => {
      state.showAddCartSuccessMessage = false;
    },
    enableAddStoreSuccessMessage: (state) => {
      state.showAddStoreSuccessMessage = true;
    },
    disableAddStoreSuccessMessage: (state) => {
      state.showAddStoreSuccessMessage = false;
    },
    setCartLoadingTrue: (state) => {
      state.isLoading = true;
    },
    setCartLoadingFalse: (state) => {
      state.isLoading = false;
    },
    setCartOpened: (state, action: PayloadAction<boolean>) => {
      state.isOpened = action.payload;
    },
  },
});

export const {
  setCartItems,
  setCartCountObject,
  updateCartCountObject,
  enableAddCartSuccessMessage,
  disableAddCartSuccessMessage,
  enableAddStoreSuccessMessage,
  disableAddStoreSuccessMessage,
  setCartLoadingTrue,
  setCartLoadingFalse,
  setCartOpened,
} = cartSlice.actions;

export default cartSlice.reducer;
